var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',{staticClass:"v-back-button",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('arrow-back-icon'),_vm._v(" "+_vm._s(_vm.$text['forms']['return'])+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }